import React from "react"
import {useSolution} from "../AppContext"

export const PlanningName = () => {
    const solution = useSolution()

    return solution.hasPlannings() ? solution.getCurrentSolution().name : '-'
}
